(function () {
  'use strict';

  var grid = document.querySelector('#product-grid');
  if (!grid) return;

  // Hide pagination
  var pagination = document.querySelector('.pagination');
  if (pagination) pagination.style.display = 'none';

  // Find next-page URL
  function findNextUrl(doc, currentPage) {
    var links = Array.from(doc.querySelectorAll('.pagination a'));
    var match = links.find(function (a) {
      var m = (a.href || '').match(/[?&]page=(\d+)/);
      return m && parseInt(m[1]) === currentPage + 1;
    });
    return match ? match.href : null;
  }

  var loadedPage = (function () {
    var m = window.location.search.match(/[?&]page=(\d+)/);
    return m ? parseInt(m[1]) : 1;
  })();

  var nextUrl = findNextUrl(document, loadedPage);
  var loading = false;

  // Sold-out = Notify Me button
  function isSoldOut(li) {
    return !!li.querySelector('.alr-view-btn[href^="#alr-"]');
  }

  // Move sold-out cards to end
  function sortSoldOutToBottom() {
    Array.from(grid.children).forEach(function (li) {
      li.style.order = isSoldOut(li) ? '1' : '0';
    });
  }

  // Re-run inline scripts inside newly appended items
  // (scripts in innerHTML/DOMParser-inserted nodes don't execute automatically)
  function executeScripts(container) {
    Array.from(container.querySelectorAll('script')).forEach(function (old) {
      if (old.src) return;
      var s = document.createElement('script');
      s.textContent = old.textContent;
      old.parentNode.replaceChild(s, old);
    });
  }

  // Re-initialise Judge.me badges
  function reinitJudgeMe() {
    try {
      if (window.jdgm && typeof window.jdgm.initializeWidgets === 'function') {
        if (grid.querySelector('.jdgm-widget:not(.jdgm--done-setup)')) {
          window.jdgm.initializeWidgets(grid);
        }
      }
    } catch (e) {}
  }

  // Fetch next page and append
  function loadMore() {
    if (loading || !nextUrl) return;
    loading = true;
    fetch(nextUrl)
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.querySelector('#product-grid');
        if (newGrid && newGrid.children.length) {
          // Collect new items first
          var newItems = Array.from(newGrid.children);
          // Append to grid
          newItems.forEach(function (li) { grid.appendChild(li); });
               // Pre-fetch lazy hover images so first-hover is instant
               newItems.forEach(function (li) {
                 li.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
                   var s = img.getAttribute('src') || img.src;
                   if (s) { var p = new Image(); p.src = s; }
                 });
               });
          loadedPage++;
          nextUrl = findNextUrl(doc, loadedPage);
          // Re-execute scripts for each new card
          newItems.forEach(function (li) { executeScripts(li); if (window._setupAloCard) { li.querySelectorAll('.card-wrapper').forEach(window._setupAloCard); } });
          reinitJudgeMe();
        } else {
          nextUrl = null;
        }
        loading = false;
        checkScroll();
      })
      .catch(function () { loading = false; });
  }

  // Scroll-based trigger
  function checkScroll() {
    if (!nextUrl || loading) return;
    var scrolledTo = window.scrollY + window.innerHeight;
    var pageHeight = document.documentElement.scrollHeight;
    if (scrolledTo >= pageHeight - 1000) {
      loadMore();
    }
  }

  window.addEventListener('scroll', checkScroll, { passive: true });

  // Sort on init
  sortSoldOutToBottom();

  // Eagerly load next page
  loadMore();
})();